const data = [
    {
        id:1,
        title:"Accounting",
        image:"img/project/proj-1.png",
        category: "developing",
        details:"Software Solution",
    },
    {
        id:2,
        title:"Projects",
        image:"img/project/proj-2.png",
        category: "web",
        details:"Managment System",
    },
    {
        id:3,
        title:"HRM",
        image:"img/project/proj-3.png",
        category: "App",
        details:"Solution",
    },
    {
        id:4,
        title:"MLM",
        image:"img/project/proj-4.png",
        category: "UI",
        details:"Investment Solution",
    },
    {
        id:5,
        title:"CRM",
        image:"img/project/proj-5.png",
        category: "Graphic",
        details:"Solution",
    },
    {
        id:6,
        title:"Team",
        image:"img/project/proj-6.png",
        category: "3D Design",
        details:"Management System",
    },
    // {
    //     id:7,
    //     title:"3D Design",
    //     image:"img/project/project-5.jpg",
    //     category: "Graphic",
    //     details:"Low Poly Base Mesh",
    // },
    // {
    //     id:8,
    //     title:"3D Design",
    //     image:"img/project/project-1.jpg",
    //     category: "Graphic",
    //     details:"Low Poly Base Mesh",
    // },
    // {
    //     id:9,
    //     title:"UI Kit",
    //     image:"img/project/project-2.jpg",
    //     category: "UI",
    //     details:"Low Poly Base Mesh",
    // },
    // {
    //     id:10,
    //     title:"UI Kit",
    //     image:"img/project/project-4.jpg",
    //     category: "UI",
    //     details:"Low Poly Base Mesh",
    // },
    // {
    //     id:11,
    //     title:"App",
    //     image:"img/project/project-3.jpg",
    //     category: "App",
    //     details:"Mobile Crypto Wallet",
    // },
    // {
    //     id:12,
    //     title:"App",
    //     image:"img/project/project-1.jpg",
    //     category: "App",
    //     details:"Mobile Crypto Wallet",
    // },
];

export default data;